import R from 'ramda'

const FACEBOOK_COMMENT_DISPLAY_TYPE = 'Send Facebook Comment'
const FACEBOOK_COMMENT_WIDGET_TYPE = 'SEND_FACEBOOK_COMMENT'

const isFacebookCommentFormAction = R.propEq(
  'type',
  FACEBOOK_COMMENT_DISPLAY_TYPE
)

const convertFacebookCommentFormActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_COMMENT_WIDGET_TYPE),
  message: {
    message: R.prop('message'),
    attachment_url: R.prop('attachmentUrl'),
    attachment_share_url: R.prop('attachmentShareUrl')
  }
})

export {
  isFacebookCommentFormAction,
  convertFacebookCommentFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-comment.js